import React, {useEffect} from 'react';

import {CommonProvider} from '@yandex-data-ui/common';
import {Provider} from 'react-redux';
import ErrorBoundary from 'ui/components/ErrorBoundary';
import store, {selectors, useAppSelector} from 'ui/store';

const {selectTheme} = selectors;

const {lang} = window.YC;

const withCommon = <P extends {}>(Component: React.FC<P>) =>
    function WithCommonProvider(props: P) {
        const theme = useAppSelector(selectTheme);

        useEffect(() => {
            // TODO: delete in FORMS-11412
            const bodyEl = document.body;
            if (['ar', 'he'].includes(lang)) {
                bodyEl.setAttribute('dir', 'rtl');
            } else {
                bodyEl.removeAttribute('dir');
            }
        }, []);

        return (
            <CommonProvider theme={theme}>
                <Component {...props} />
            </CommonProvider>
        );
    };

export const withErrorBoundary = <P extends {}>(Component: React.FC<P>) =>
    function WithErrorBoundaryProvider(props: P) {
        return (
            <ErrorBoundary>
                <Component {...props} />
            </ErrorBoundary>
        );
    };

const withRedux = <P extends {}>(Component: React.FC<P>) =>
    function WithReduxProvider(props: P) {
        return (
            <Provider store={store}>
                <Component {...props} />
            </Provider>
        );
    };

export const withAppProviders = <Props extends object>(Component: React.FC<Props>) => {
    return withErrorBoundary(withRedux(withCommon(Component)));
};
